/**
 * Handles image loading errors by hiding the broken image
 * @param event - The error event from the image element
 */
export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
	console.log("Image failed to load:", event.currentTarget.src);
	// Hide broken image
	event.currentTarget.style.display = 'none';
};
